import { WorkItemListService } from 'common/workitems/workitem-list.service';
import { Component, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { BcAnalytics } from 'common/analytics/analytics.service';
import * as moment from 'moment';
import { SearchQuery } from 'components/accordion/search-widget/model/search-query.model';

@Component({
  selector: 'app-search-results-panel',
  templateUrl: './search-results-panel.component.html',
  styleUrls: ['./search-results-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchResultsPanelComponent {
  @Input()
  resultsVisible: boolean;

  @Input()
  searchObject: SearchQuery;

  @Output()
  resultsVisibleChange = new EventEmitter<boolean>();

  constructor(private _bcAnalytics: BcAnalytics,
              private _workItemListService: WorkItemListService) { }

  public backToFilters(): void {
    this.resultsVisible = false;
    this.resultsVisibleChange.emit(this.resultsVisible);
  }

  public openWorkItem(result): void {
    this._workItemListService.selectWorkitem(result);
    this._bcAnalytics.eventTrack('OpenPastConversationItem', { type: result.type });
  }

  public getFormattedDateProperty(date: string): string {
    return moment(date).format('ll');
  }
}
